import { CardContent, Typography } from "@mui/material";
import Card from "@mui/material/Card";

export default function SingleInfoCard({
  title,
  value,
  subtitle,
  valueColor = "text.primary",
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        ml: 2,
        mr: 2,
        mt: 1,
        mb: 1,
        p: 2,
        backgroundColor: "background.default",
      }}
    >
      <CardContent>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", color: valueColor }}>
          {value}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {subtitle}
        </Typography>
      </CardContent>
    </Card>
  );
}
